import React, { useState } from "react";

//components
import { FormRegister, AuthLogoHeader } from "@components/auth";

// Modal Message
import { ModalMessageAuth } from "@components/auth/ModalMessage";

function RegisterPageV2(props) {
  const [dataRegister, setDataRegister] = useState(null)

  return (
    <div className="wrapper -loginPageV2">
      <AuthLogoHeader {...props} />
      <div className="login_panel">
        {dataRegister?.buttons ? (
          <ModalMessageAuth dataMessage={dataRegister} />
        ) : (
          <FormRegister setDataRegister={setDataRegister} />
        )}
      </div>
    </div>
  );
}

export default RegisterPageV2;